export default __webpack_public_path__ + "static/media/image10.923969b4.jpg";